import getFifteenMinutesAgo from './utils/getFifteenMinutesAgo'
import getHalfHourAgo from './utils/getHalfHourAgo'
import getLastHourAgo from './utils/getLastHourAgo'
import getSixHourAgo from './utils/getSixHourAgo'
import getTwelveHoursAgo from './utils/getTwelveHoursAgo'
import getTwentyFourHoursAgo from './utils/getTwentyFourHoursAgo'
import getLastMonthAgo from './utils/getLastMonthAgo'
import getSevenDaysAgo from './utils/getSevenDaysAgo'
import getFourteenDaysAgo from './utils/getFourteenDaysAgo'
import getThirtyDaysAgo from './utils/getThirtyDaysAgo'
import getToday from './utils/getToday'
import getYesterday from './utils/getYesterday'

export type DateShortCut = {
  startDate: string
  finalDate: string
  name: string
  label: string
}

export default function getPossibleDateIntervals() {
  return {
    FIFTEEN_MINUTES_AGO: getFifteenMinutesAgo,
    HALF_HOUR_AGO: getHalfHourAgo,
    LAST_HOUR: getLastHourAgo,
    SIX_HOURS_AGO: getSixHourAgo,
    TWELVE_HOURS_AGO: getTwelveHoursAgo,
    TWENTY_FOUR_HOURS_AGO: getTwentyFourHoursAgo,
    TODAY: getToday,
    YESTERDAY: getYesterday,
    SEVEN_DAYS_AGO: getSevenDaysAgo,
    FOURTEEN_DAYS_AGO: getFourteenDaysAgo,
    THIRTY_DAYS_AGO: getThirtyDaysAgo,
    LAST_MONTH: getLastMonthAgo,
  }
}
